/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

  function toggle_atl(){
    console.log( 'atl: ' + document.querySelector('.atl-cart').checked );
    if ( document.querySelector('.atl-cart').checked ) {
      set_atl_val("yes");
    } else {
      set_atl_val("no");
    }
  }

  function init_atl(){
    get_atl_val(); 
  }

  function set_atl_val(value){
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'authority_to_leave': value,
        }
      })
    })
    .then(response => response.json())
    .then(cart => {
      // console.log('Updated cart attributes:', cart.attributes);
    })
    .catch(error => console.error('Error updating attributes:', error));
  }

  function get_atl_val(){
    fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // console.log('Current attributes:', cart.attributes);      
      var target_val = cart.attributes['authority_to_leave'];
      // console.log('authority_to_leave:', target_val);

      if (target_val == undefined) {
        set_atl_val("yes");
        document.querySelector('.atl-cart').checked = true;
      } else if (target_val == "yes") {        
        // set_atl_val("yes");
        document.querySelector('.atl-cart').checked = true;
      } else {
        set_atl_val("no");
        document.querySelector('.atl-cart').checked = false;
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
  }